// @flow
import * as React from 'react';

import { FormFeedback } from 'Components/frameworks/form-feedback/FormFeedback.jsx';
import type { FormErrorsType } from './participants.validator.js';

type ParticipantsErrorsProps = {
  config: {
    errorMaxGuestsLabel?: string,
    departureDateErrorMessage?: string,
  },
  errors: FormErrorsType,
  isSubmitted: boolean,
};

function ParticipantsErrors({ config, errors, isSubmitted }: ParticipantsErrorsProps) {
  const { maxPax, departureDate, birthdays, birthdaysErrorMessage } = errors;

  if (maxPax) {
    return (
      <div className="BookingFormErrorMessage GuestExceededErrorMessage">
        <FormFeedback isError message={config.errorMaxGuestsLabel} />
      </div>
    );
  }

  if (isSubmitted && departureDate) {
    return (
      <div className="BookingFormErrorMessage DepartureDateErrorMessage">
        <FormFeedback
          className="DepartureDateErrorMessage--error"
          isError
          message={config.departureDateErrorMessage}
        />
      </div>
    );
  }

  if (isSubmitted && birthdays) {
    return (
      <div className="BookingFormErrorMessage BirthdayErrorMessage">
        <FormFeedback isError message={birthdaysErrorMessage} />
      </div>
    );
  }

  return null;
}

export default ParticipantsErrors;
